<template>
    <div>
        <!-- DESARROLLLO INICIADO EL MARTES 24-09-2020 ING WUILMER GARCIA-->
        <!-- mensajes de confirmacion -->
        <mensajeSistema></mensajeSistema>
        <v-tabs v-model="tab" dark class="rounded-lg" dense background-color="primary" active-class="tab-active"
            slider-color="#ffbc00" centered>
            <v-tab class="font-weight-black"> Competencias, capacidades y desempeños</v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab" touchless>
            <v-tab-item class="py-4">
                <component :is="compAsignarCompetencia" :estadoComp="estadoAsignarCompetencia"
                    :parametros="parametroAsignarCompetencia">
                </component>
            </v-tab-item>
        </v-tabs-items>

    </div>
</template>
<script>
import { mapMutations, mapGetters, mapActions } from 'vuex';
import ConfigCurriculoCol from '@/views/Mantenimiento/Competencia/components/ConfigCurriculoCol.vue'
import AsignarCompetenciaCol from '@/views/Mantenimiento/Competencia/components/AsignarCompetenciaCol1.vue'

export default {
    name: 'configCompetencia',
    components: {
        ConfigCurriculoCol,
        AsignarCompetenciaCol
    },
    data: () => ({
        tab: 0,
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        paramComponente: { 'id_submodulo': 89, "id_modulo": 5 }, //sud_modulo y modulo
        datoLogin: sessionStorage, // variables de sesion del usuario
        ////////////////////////////////////////////////////////
        // componente configuración de Curriculo           
        compConfigCurriculo: null,
        estadoConfigCurriculo: false,
        parametroConfigCurriculo: {},
        // componente Asignar Competencias
        compAsignarCompetencia: true,
        estadoAsignarCompetencia: true,
        parametroAsignarCompetencia: {},
    }),

    computed: {
        ...mapGetters('login', ['componenteEvento']),
    },
    mounted() {
        this.loadMain()
    },
    created() {
        this.actualizarParamentro()
    },
    methods: {
        //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
        //  ------- MENSAJE DE SISTEMA  --------
        ...mapMutations('mensajeSis', ['setEnviarMens']),

        //----- Validar accesos por perfil ------------
        ...mapActions('login', ['parametroComponente']),

        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        ////////////////////////////////////////////////////////

        loadMain() {
            this.getAsignarCompetencia()
        },
        // componente Configuracion Curriculo
        async getConfigCurriculo() {

            await this.limpiarForm()
            this.estadoConfigCurriculo = true
            this.parametroConfigCurriculo = {}
        },

        // componente Asignar Competencia
        async getAsignarCompetencia() {
            await this.limpiarForm()
            this.parametroAsignarCompetencia = {}
            this.estadoAsignarCompetencia = true
            this.compAsignarCompetencia = "AsignarCompetenciaCol"
        },


        limpiarForm() {
            this.estadoConfigCurriculo = false
            this.estadoAgregarCompetencia = false
            this.estadoAsignarCompetencia = true
        },


    },
}
</script>